//메인 화면 동아리 미리보기 영역
import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import ClubCard from "./ClubCard";
import { supabase } from "../../lib/supabaseClient";
import "./ClubPreviewSection.css";

function parseCategories(category) {
  if (!category) return [];
  if (Array.isArray(category)) return category;
  try { return JSON.parse(category); } catch { return [category]; }
}

function ClubPreviewSection({ activeTag }) {
  const [clubs, setClubs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // 컴포넌트 마운트 시 1회만 Supabase에서 승인된 동아리 목록 전체를 불러옴
  // 이후 필터링은 클라이언트에서 useMemo로 처리해 불필요한 API 재호출 방지
  useEffect(() => {
    const fetchClubs = async () => {
      const { data, error } = await supabase
        .from("clubs")
        .select("id, name, recruitment_status, description, image_url, category, member_count")
        .eq("approval_status", "승인");  // 관리자가 승인한 동아리만 표시

      if (!error && data) {
        setClubs(data);
      }
      setIsLoading(false);
    };

    fetchClubs();
  }, []);

  // useMemo: clubs 또는 activeTag가 바뀔 때만 재계산 → 불필요한 filter 연산 방지
  // "전체" 태그이면 전체 목록에서 최대 6개, 특정 카테고리이면 해당 카테고리만 필터링 후 최대 6개 표시
  const filteredClubs = useMemo(() => {
    if (!activeTag || activeTag === "전체") return clubs.slice(0, 6);
    return clubs
      .filter((club) => parseCategories(club.category).includes(activeTag))
      .slice(0, 6);
  }, [clubs, activeTag]);

  return (
    <section className="club-preview-section">
      <div className="club-preview-header">
        <h3 className="club-preview-title">동아리</h3>
        <span className="club-preview-more" onClick={() => navigate('/clubs')}>전체보기 →</span>
      </div>

      {isLoading ? (
        <div className="club-preview-skeleton">
          {[...Array(3)].map((_, i) => <div key={i} className="skeleton-card" />)}
        </div>
      ) : filteredClubs.length === 0 ? (
        <div className="club-preview-empty">해당 카테고리의 동아리가 없어요</div>
      ) : (
        <div className="club-preview-grid">
          {filteredClubs.map((club) => (
            <ClubCard key={club.id} club={club} />
          ))}
        </div>
      )}
    </section>
  );
}

export default ClubPreviewSection;
